<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 门店编辑
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
           
            
            
        </div>

        <!-- 添加弹出框 -->
        <el-dialog title="添加门店" :visible.sync="addVisiable" width="1100px">
            <el-form ref="addForm" :rules="rules" :model="addForm" label-width="120px" inline="" >
                <el-form-item v-if="role == 1" label="管理员" prop="id">
                    <el-select v-model="addForm.id" filterable class="inputclass">
                        <el-option
                            v-for="item in maList"
                            :key="item.id"
                            :label="item.username"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="账号" prop="username">
                    <el-input class="inputclass" v-model="addForm.username"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input class="inputclass" v-model="addForm.password"></el-input>
                </el-form-item>
                <el-form-item label="门店名称" prop="company">
                    <el-input class="inputclass" v-model="addForm.company"></el-input>
                </el-form-item>
                <el-form-item label="门店电话" prop="phone">
                    <el-input class="inputclass" v-model="addForm.phone"></el-input>
                </el-form-item>
                <el-form-item label="提现手续费(%)" prop="poundage">
                    <el-input class="inputclass" v-model="addForm.poundage"></el-input>
                </el-form-item>
                <el-form-item label="开始营业" prop="startTime">
                     <el-time-select
                        class="inputclass"
                        v-model="addForm.startTime"
                         placeholder="开始时间"
                        :picker-options="{
                        start: '00:00',
                        step: '00:10',
                        end: '23:50',
                    }">
                     </el-time-select>
                </el-form-item>
                <el-form-item label="结束营业" prop="endTime">
                    <el-time-select
                    class="inputclass"
                        placeholder="结束时间"
                        v-model="addForm.endTime"
                        :picker-options="{
                        start: '00:00',
                        step: '00:10',
                        end: '23:50',
                        minTime: startTime
                        }">
                    </el-time-select>
                </el-form-item>
                <el-form-item label="门店logo" prop="logo"  >
                    <el-upload
                        :limit="1"
                        action="http://localhost:9999/cat/adopt/insertAdopt"
                        ref="uploadimg"
                        list-type="picture-card"
                        :auto-upload="false"
                        :data="addForm"
                        :file-list="addForm.logo"
                        :on-remove="handleRemove"
                        :on-change="handleChange"
                        :http-request="uploadFile">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="门店地址" prop="address">
                    <el-button @click="mapVisiable=true">点击获取</el-button>
                    <el-input style="width:350px" v-model="addForm.address"></el-input>
                </el-form-item>
                <el-dialog :visible.sync="mapVisiable" width="1100px">
                     <baidu-map
                    v-bind:style="mapStyle"
                    class="bm-view"
                    ak="G1i75yz8WZEz871mIscsk4NTplkSakWB"
                    :center="center"
                    :zoom="zoom"
                    :scroll-wheel-zoom="true"
                    @click="getClickInfo"
                    @moving="syncCenterAndZoom"
                    @moveend="syncCenterAndZoom"
                    @zoomend="syncCenterAndZoom"
                    >
                    <bm-view style="width: 100%; height:500px;"></bm-view>
                    <bm-marker
                        :position="{ lng: center.lng, lat: center.lat }"
                        :dragging="true"
                        animation="BMAP_ANIMATION_BOUNCE"
                    >
                    </bm-marker>
                    <bm-control :offset="{ width: '10px', height: '10px' }">
                        <bm-auto-complete v-model="addForm.address" :sugStyle="{ zIndex: 999999 }">
                        <input
                            type="text"
                            placeholder="请输入搜索关键字"
                            class="serachinput"
                            v-model="addForm.address"
                        />
                        </bm-auto-complete>
                    </bm-control>
                    <bm-local-search
                        :keyword="addForm.address"
                        :auto-viewport="true"
                        style="width:0px;height:0px;overflow: hidden;"
                    ></bm-local-search> </baidu-map
                >
                </el-dialog>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisiable = false">取 消</el-button>
                <el-button type="primary" @click="addData()">确 定</el-button>
            </span>
        </el-dialog>
         <!-- 编辑弹出框 -->
        <el-dialog title="编辑门店" :visible.sync="editVisible" width="1100px" >
            <el-form ref="editForm" :rules="rules" :model="editForm" label-width="120px" inline="">
                 <el-form-item label="账号" prop="username">
                    <el-input  class="inputclass" v-model="editForm.username"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input class="inputclass" v-model="editForm.password"></el-input>
                </el-form-item>
                <el-form-item label="门店名称" prop="company">
                    <el-input class="inputclass" v-model="editForm.company"></el-input>
                </el-form-item>
                <el-form-item label="提现手续费(%)" prop="poundage">
                    <el-input class="inputclass" v-model="editForm.poundage"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="phone">
                    <el-input class="inputclass" v-model="editForm.phone"></el-input>
                </el-form-item>
                <el-form-item label="开始营业" prop="startTime">
                     <el-time-select
                     class="inputclass"
                        v-model="startTime"
                         placeholder="开始时间"
                        :picker-options="{
                        start: '00:00',
                        step: '00:10',
                        end: '23:50',
                    }">
                     </el-time-select>
                </el-form-item>
                <el-form-item label="结束营业" prop="endTime">
                    <el-time-select
                    class="inputclass"
                        placeholder="结束时间"
                        v-model="endTime"
                        :picker-options="{
                        start: '00:00',
                        step: '00:10',
                        end: '23:50',
                        minTime: startTime
                        }">
                    </el-time-select>
                </el-form-item>
                <el-form-item label="门店logo" prop="logoarray">
                    <el-upload
                        :limit="1"
                        action="http://localhost:9999/cat/adopt/insertAdopt"
                        ref="uploadimg1"
                        list-type="picture-card"
                        :auto-upload="false"
                        :data="editForm"
                        :file-list="editForm.logoarray"
                        :on-remove="handleRemove1"
                        :on-change="handleChange1"
                        :http-request="uploadFile">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="门店地址" prop="address">
                    <el-input style="width:600px" v-model="editForm.address"></el-input>
                </el-form-item>
                    <baidu-map
                        v-bind:style="mapStyle"
                        class="bm-view"
                        ak="G1i75yz8WZEz871mIscsk4NTplkSakWB"
                        :center="editForm.center"
                        :zoom="zoom"
                        :scroll-wheel-zoom="true"
                        @click="getClickInfo1"
                        @moving="syncCenterAndZoom1"
                        @moveend="syncCenterAndZoom1"
                        @zoomend="syncCenterAndZoom1"
                        >
                        <bm-view style="width: 100%; height:500px;"></bm-view>
                        <bm-marker
                            :position="{ lng: editForm.center.lng, lat: editForm.center.lat }"
                            :dragging="true"
                            animation="BMAP_ANIMATION_BOUNCE"
                        >
                        </bm-marker>
                        <bm-control :offset="{ width: '10px', height: '10px' }">
                            <bm-auto-complete v-model="editForm.address" :sugStyle="{ zIndex: 999999 }">
                            <input
                                type="text"
                                placeholder="请输入搜索关键字"
                                class="serachinput"
                                v-model="editForm.address"
                            />
                            </bm-auto-complete>
                        </bm-control>
                        <bm-local-search
                            :keyword="editForm.address"
                            :auto-viewport="true"
                            style="width:0px;height:0px;overflow: hidden;"
                        ></bm-local-search> </baidu-map
                    >
            </el-form>     
             <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit()">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
 
import {post} from '../../../api/request.js'
import {
  BaiduMap,
  BmControl,
  BmView,
  BmAutoComplete,
  BmLocalSearch,
  BmMarker
} from 'vue-baidu-map'
export default {
    
    name: 'basetable',
    components: {
        BaiduMap,
        BmControl,
        BmView,
        BmAutoComplete,
        BmLocalSearch,
        BmMarker
    },
    props: {
    visible: Boolean,
    value: {
      type: Boolean,
      default: false
    },
    mapHeight: {
      type: Number,
      default: 500
    }
  },
  
    data() {
        var poundage = (rule, value, callback) => {
            const reg = /^\d+.?\d{0,2}$/
            if (!value) {
                callback(new Error('请输入提现手续费'))
            } else if (!Number(value)) {
                callback(new Error('请输入数字值'))
            } else if(value<=0||value>=100){
                callback(new Error('请输入大于0小于100的数字'))
            }else {
                if (reg.test(value)) {
                callback()
                } else {
                callback(new Error('小数点后最多只能输入两位'))
                }
            }
        }
        return {
            mapVisiable:false,
            showMapComponent: this.value,
            keyword: '',
            mapStyle: {
                width: '100%',
                height: this.mapHeight + 'px'
            },
            center: { lng: 104.710326, lat: 27.118777 },
            center1: { lng: 104.710326, lat: 27.118777 },
            zoom: 15,
            upvisiable:'',
            hideUpload: false,
            dialogImageUrl: '',
            dialogVisible: false,//图片预览弹窗
            formLabelWidth: '80px',
            limitNum: 1,
            form: {},
            dialogVisible2: false,//弹窗
            //营业时间
            logourl:'',
            role:'',//登录角色
            maList:[],//管理员列表
            query: {
                company: '',
                pageIndex: 1,
                pageSize: 8
            },
            showMapComponent:true,
             //添加数据
            addVisiable:false,
            addForm:{
                username:'',
                password:'',
                company:'',
                id:'',
                address:'',
                startTime: '',
                endTime: '',
                logo:[],
                poundage:''
            },
            fileList:[],
            url:'',
            //编辑数据
            editVisible:false,
            editForm:{
                center: { lng: 104.710326, lat: 27.118777 },
            },
            startTime: '',
            endTime: '',
            //添加数据表单验证
            rules: {
                id: [ { required: true, message: '请选择id', trigger: 'blur' }, ],
                company: [{ required: true, message: '请输入门店名称', trigger: 'change' }, ],
                username: [ { required: true, message: '请输入管理员名称', trigger: 'blur' },],
                password: [ { required: true, message: '请输入密码', trigger: 'change' },
                { min: 6, max: 18, message: '长度在 6 到 18 个字符', trigger: 'blur' }],
                address: [ { required: true, message: '请输入地址', trigger: 'change' }],
                startTime: [ { required: true, message: '请选择时间', trigger: 'change' }],
                endTime: [ { required: true, message: '请选择时间', trigger: 'change' }],
                logo:[ { required: true, message: '请选择图片', trigger: 'change' }],
                poundage:[ { required: true, validator:poundage, trigger: 'change'}],
                phone:[ { required: true, message: '请输入门店电话', trigger: 'change' },]
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
            formdata:'',
            upvisiable:false
        };
    },
   
    created() {
        this.getData()
        this.role =  parseInt(sessionStorage.getItem('roleid'))
        this.getList()
    },
    activated() {
        this.getData()
    },
    methods: {
        getClickInfo (e) {
            this.center.lng = e.point.lng
            this.center.lat = e.point.lat
        },
        syncCenterAndZoom (e) {
            const { lng, lat } = e.target.getCenter()
            this.center.lng = lng
            this.center.lat = lat
            this.zoom = e.target.getZoom()
            console.log(this.center)
        },
        getClickInfo1 (e) {
            this.editForm.center.lng = e.point.lng
            this.editForm.center.lat = e.point.lat
        },
        syncCenterAndZoom1(e) {
            const { lng, lat } = e.target.getCenter()
            this.editForm.center.lng = lng
            this.editForm.center.lat = lat
            this.zoom = e.target.getZoom()
        
        },
   	// const obj = { 经度: e.lng, 纬度: e.lat }
  	// const arr = []
   	// for (var k in obj) {
   	//   const str = k + ':' + obj[k]
   	//   arr.push(str)
   	// }
   	// this.form.longitudeLatitude = arr.join(',')
   	// this.form.longitude = e.lng + ''
         //重置搜索
        resetsearch(){
            this.query.company= '',
            this.getData()
        },
        removeImage(file, fileList){
            const tmp_path  = file.response
            if(fileList.length < 1) {
                 this.uploadDisabled = true //未选择文件则禁用上传按钮
             }
        },
        handleChange (file, fileList) {
            this.addForm.logo = fileList;
        },
        handleRemove(file, fileList) {
            this.addForm.logo = fileList;
        },
        handleChange1 (file, fileList) {
            this.editForm.logoarray = fileList;
        },
        handleRemove1(file, fileList) {
            this.addForm.logoarray = fileList;
        },
        handlePictureCardPreview(file) {
            this.adoptFormdialogImageUrl = file.url;
            this.adoptFormdialogVisible = true;
        },
        uploadFile(file){
            this.upvisiable = true
            this.formdata.append('file', file.file);
        },
        //上传图片
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        beforeUpload(file) {
            let _this = this;
            let _checkSize = false;  //是否需要指定上传图片的尺寸
            if(file.size > 1024*500) {  //大小超过500kb
                _this.$message.error('图片太大，请重新选择');
                return false;
            }
            const isSize = new Promise((resolve, reject)=>{
                let _URL = window.URL || window.webkitURL;
                let img = new Image();
                img.onload = function () {
                    if(!_checkSize || (_checkSize && img.width==_this.imgWidth && img.height==_this.imgHeight)) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                }
                img.src = _URL.createObjectURL(file);
            }).then(()=>{
                return file;
            },()=>{
                _this.$message.error('图片尺寸不对，请重新选择');
                return Promise.reject();
            });
            return isSize;
        }  ,
        resetForm(formName) {
                this.$refs[formName].resetFields();
        },
        //添加数据
        addData(){
            this.formdata = new FormData()
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            this.$refs.uploadimg.submit();
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    post("/admin/file/url",this.formdata,config).then( res => {
                        this.formdata = new FormData()
                        this.formdata.append('logo',res.data)
                        let str = '';
                        str += this.addForm.startTime +'-' +this.addForm.endTime
                        this.formdata.append('company',this.addForm.company)
                        this.formdata.append('username',this.addForm.username)
                        this.formdata.append('password',this.addForm.password)
                        this.formdata.append('address',this.addForm.address)
                        this.formdata.append('phone',this.addForm.phone)
                        this.formdata.append('poundage',this.addForm.poundage)
                        this.formdata.append('center',JSON.stringify(this.center))
                        this.formdata.append('time',str)
                        if(this.role == 1)
                            this.formdata.append('id',this.addForm.id)
                        else{
                            this.formdata.append('id',sessionStorage.getItem('userid'))
                        }
                        post('admin/company/addcompany',this.formdata).then(res=>{
                            if(res.data.msg=="门店数量已达到上限")
                                this.$messgea.warning("门店用户达到上限")
                            else if(res.data.msg=="创建成功"){
                                this.$message.success("创建成功")
                                this.addVisiable = false
                                this.upvisiable = false
                                this.getData()
                                this.$refs['addForm'].resetFields();
                            }
                            else if(res.data.msg=="用户名不能带有中文"){
                                this.$message.error("账号不能带有中文")
                            }
                            else if(res.data.msg=="已存在该账号"){
                                this.$message.warning("已存在该账号")
                            }
                        })
                    })
                
                }
            })   
        },
        manage(index,row){
            var objname = "id=" + row.id +"&companyname=" +row.company;
            window.open('/#/homeNext?' +objname)
        },
        updateStatus(index,row){
            let formdata = new FormData()
            let url = 'admin/company/disables'
            formdata.append('id',row.id)
            if(row.disable==1){
                url = 'admin/company/starts'
            }
            post(url,formdata).then(res=>{
                if(res.data.msg =="禁用失败"){
                    this.$message.error("禁用失败")
                } 
                else if(res.data.msg =="禁用成功"){
                    this.$message.success("禁用成功")
                    this.getData()
                }
                else if(res.data.msg =="启用成功"){
                    this.$message.success("启用成功")
                    this.getData()
                }
                else if(res.data.msg =="启用失败"){
                    this.$message.error("启用失败")
                    this.getData()
                }      
            })
        },
       
        // 获取 easy-mock 的模拟数据
        getData() {
            let formdata = new FormData()
            formdata.append('company',this.query.company)
            formdata.append('page',this.query.pageIndex)
            formdata.append('limit',this.query.pageSize)
            let url ='admin/company/companyinfo'
            if(sessionStorage.getItem('roleid') != 1){
                url='admin/company/companys'
                let id = sessionStorage.getItem('userid')
                formdata.append('id',id)
            }
            post(url,formdata).then(res => {
                if(res.data.data.list){
                    this.tableData = res.data.data.list;
                    this.pageTotal = res.data.data.num
                    if (!this.tableData.length && this.query.pageIndex > 1) {
                        this.query.pageIndex--;
                        this.getData()
                }
                }
                else{
                    this.$messgea.error("暂无数据")
                }
            });
        },
        getList(){
            let formdata = new FormData()
            formdata.append('page',1)
            formdata.append('limit',1000)
            formdata.append('username','')
            post('admin/admin_user/userinfo',formdata).then(res=>{
                if(res.data)
                {
                    this.maList = res.data.data.list
                }
            })
        },
        // 触发搜索按钮
        inputSearch() {
            let formdata = new FormData()
                formdata.append('company',this.query.company)
                formdata.append('page',1)
                formdata.append('limit',this.query.pageSize)
                let url ='admin/company/companyinfo'
                if(sessionStorage.getItem('roleid') != 1){
                    url='admin/company/companys'
                    let id = sessionStorage.getItem('userid')
                    formdata.append('id',id)
                }
                post(url,formdata).then(res => {
                    if(res.data.data.list.length >=0){
                        this.tableData = res.data.data.list;
                        this.pageTotal = res.data.data.num
                    }
                });
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    let formdata = new FormData()
                    formdata.append('id',row.id)
                    post('admin/company/delecompany',formdata).then(res=>{
                        if(res.data.msg=="删除成功"){
                            this.$message.success('删除成功');
                            this.getData()
                        }
                        else
                            this.message.error('删除失败')
                    })
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].id + ',';
            }
            let formdata = new FormData()
            formdata.append('id',str)
            post('admin/company/alldele',formdata).then(res=>{
                if(res.data.msg == "删除成功"){
                    this.multipleSelection = [];
                    this.$message.success('删除成功')
                    this.getData()
                    
                }
                else{
                    this.$message.error('删除失败')
                }
            })
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            this.editForm = Object.assign({}, row);;
            let ary = this.editForm.time.split("-");
            this.startTime = ary[0]
            this.endTime = ary[1]
            this.editForm.startTime = this.startTime;
            this.editForm.endTime = this.endTime;
            this.editVisible = true;
            let array = [{
                url:'',
                name:'1'
            }]
            array[0].url =this.editForm.logo
            this.editForm.logoarray=array
            this.center1.lat = this.editForm.lat
            this.center1.lng = this.editForm.lng
            this.editForm.center =  this.center1
        },
        // 保存编辑
        saveEdit(url2) {
            this.formdata = new FormData()
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            console.log()
            this.$refs.uploadimg1.submit();
            this.$refs['editForm'].validate((valid) => {
            if (valid) {
                if(this.upvisiable){
                    post("/admin/file/url",this.formdata,config).then( res => {
                    this.upvisiable = false
                    let formdata = new FormData()
                    let str = '';
                    str += this.startTime +'-' +this.endTime
                    formdata.append('id',this.editForm.id)
                    formdata.append('username',this.editForm.username)
                    formdata.append('company',this.editForm.company)
                    formdata.append('password',this.editForm.password)
                    formdata.append('address',this.editForm.address)
                    formdata.append('center',JSON.stringify(this.editForm.center))
                    formdata.append('logo',res.data)
                    formdata.append('phone',this.editForm.phone)
                    formdata.append('poundage',this.editForm.poundage)
                    formdata.append('time',str)
                    post('admin/company/updatecompany',formdata).then(res=>{
                        if(res.data.msg == "修改成功"){
                            this.getData()
                            this.$message.success('修改成功')
                            this.editVisible = false
                        }
                        else if(res.data.msg=="用户名不能带有中文"){
                                this.$message.error("账号不能带有中文")
                            }
                        else{
                            this.$message.error('修改失败')
                        }
                    
                    })
                    
                })
                }
                else{
                    let formdata = new FormData()
                    let str = '';
                    str += this.startTime +'-' +this.endTime
                    formdata.append('id',this.editForm.id)
                    formdata.append('username',this.editForm.username)
                    formdata.append('company',this.editForm.company)
                    formdata.append('password',this.editForm.password)
                    formdata.append('address',this.editForm.address)
                    formdata.append('logo',this.editForm.logo)
                    formdata.append('phone',this.editForm.phone)
                    formdata.append('center',JSON.stringify(this.editForm.center))
                    formdata.append('poundage',this.editForm.poundage)
                    formdata.append('time',str)
                    post('admin/company/updatecompany',formdata).then(res=>{
                        if(res.data.msg == "修改成功"){
                            this.getData()
                            this.$message.success('修改成功')
                            this.editVisible = false
                        }
                        else if(res.data.msg=="用户名不能带有中文"){
                                this.$message.error("账号不能带有中文")
                            }
                        else{
                            this.$message.error('修改失败')
                        }
                    
                    })
                }
            }
            })             
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.serachinput {
  width: 300px;
  box-sizing: border-box;
  padding: 9px;
  border: 1px solid #dddee1;
  line-height: 20px;
  font-size: 16px;
  height: 38px;
  color: #333;
  position: relative;
  border-radius: 4px;
  -webkit-box-shadow: #666 0px 0px 10px;
  -moz-box-shadow: #666 0px 0px 10px;
  box-shadow: #666 0px 0px 10px;
}
.next-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.inputclass{
    width: 200px;
}
</style>
